import React from 'react';
import {connect} from 'react-redux';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {Button, Grid, Form, Icon, Divider, Checkbox} from 'semantic-ui-react';
import {
  InlineSelect,
  InlineTextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {DeleteModal} from 'app-ui-componentlibrary';
import {produce} from 'immer';
import STATE_OPTIONS from 'app-ui-componentlibrary/dist/common/states';
import REST from 'go/requests/rest';

const MODALS = {
  CREATE: 'create',
  EDIT: 'edit',
  NONE: 'none',
};

export class CommunityCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: MODALS.NONE,
      selectedIndex: -1,
      community: false,
      communities: [],
      allCommunitiesSelection: [],
      options: [],
      tempOptions: [],
      showCommunity: false,
      deleteItemId: null,
    };
  }

  handleFindCommunityButton(communities) {
    this.setState({
      openModal: MODALS.CREATE,

      community: {
        type: 'custom',
      },
      options: communities,
    });
    this.state.communities = [];
    this.state.allCommunitiesSelection = [];
  }

  getCommunity = () => {
    const savedCommunity = _.cloneDeep(_.get(this.props, 'data'));
    return _.map(savedCommunity, (community) => {
      return community;
    });
  };

  updateCommunity = (community) => {
    if (this.state.tempOptions.length > 0) {
      const communityNew = [...community, ...this.state.options];
      community = [...communityNew];
      this.setState({tempOptions: []});
    }
    const {entityDataPath, entityType, data, readOnly} = this.props;
    let included = _.concat(community);
    included = _.sortBy(_.uniqBy(included, 'cidNumber'), ['communityName']);
    this.setState({
      openModal: MODALS.NONE,
      options: included,
      communities: included,
    });
    this.props.saveEntityData(entityDataPath, entityType, included);
  };

  renderFindCommunityModal() {
    let {community, communities, options} = this.state;
    if (community.type === 'custom') {
      return (
        <FemaGoModal
          closeOnDimmerClick="no"
          title="Find community"
          size="medium"
          open={this.state.openModal === MODALS.CREATE}
          disableButton={
            !community.state && !community.communityName && !community.countyName
          }
          confirmButton="hidden"
          cancelAction={() => {
            this.setState({openModal: MODALS.NONE, tempOptions: []});
          }}
        >
          <div className="modal-instructions padding-bottom">
            Communities that match your search criteria are listed below. To select one or
            more communities, select the check box under the Select column. When finished,
            click the Add Communities button.
          </div>
          <br />
          {this.renderFindCommunityForm()}
          <Button
            closeOnDimmerClick="no"
            primary
            icon
            id="searchCommunity"
            onClick={() => this.handleSearchCommunityButton(this.state.community)}
          >
            <Icon name="search" fitted />
            &nbsp;&nbsp;Search
          </Button>
          {(communities.length || options.length) > 0
            ? this.selectCommunityRecord()
            : null}
        </FemaGoModal>
      );
    }
  }

  fetchData(strSearch) {
    return REST.community
      .search(this.props.token, strSearch)
      .then(REST.handler.handleResponse);
  }

  handleSearchCommunityButton(community) {
    const stateAddress = _.toLower(_.get(this.props, 'stateAddress'));

    let strSearch = '';

    strSearch += community.state ? `state=${community.state}` : '';
    strSearch += strSearch && community.communityName ? `&` : '';
    strSearch += community.communityName
      ? `communityName=${community.communityName}`
      : '';
    strSearch += strSearch && community.countyName ? `&` : '';
    strSearch += community.countyName ? `countyName=${community.countyName}` : '';

    this.fetchData(strSearch)
      .then((response) => {
        this.setState({
          showCommunity: MODALS.CREATE,
          communities: response,
        });
      })
      .catch((error) => {
        this.setState({
          communities: [],
        });
      });
  }

  renderFindCommunityForm = () => {
    const {community} = this.state;
    const stateAddress = _.get(this.props, 'stateAddress');
    const subApplicationType = _.get(this.props, 'subApplicationType');
    community.state = _.get(community, 'state', stateAddress);
    const handleInputChange = (e) => {
      const {name, value} = e.target;
      if (name === 'state' && community.state != value) {
        community['communityName'] = '';
        community['countyName'] = '';
      }
      community[name] = value;
      this.setState({community});
    };

    return (
      <React.Fragment>
        <Form id="community-form">
          <Form.Group>
            <InlineSelect
              title="State"
              label="State"
              id="state"
              name="state"
              size="small"
              value={community.state}
              options={STATE_OPTIONS}
              disabled={
                subApplicationType === 'Indian Tribal Government' ||
                subApplicationType === undefined
                  ? false
                  : true
              }
              handleBlur={handleInputChange}
              handleChange={handleInputChange}
            />
            <InlineTextBoxField
              title="Community name"
              label="Community name (optional)"
              id="communityName"
              name="communityName"
              size="small"
              value={community.communityName}
              handleBlur={handleInputChange}
              handleChange={handleInputChange}
            />
            <div>
              <b>
                <br />
              </b>
            </div>

            <InlineTextBoxField
              title="County name"
              label="County name (optional)"
              id="countyName"
              name="countyName"
              size="small"
              value={community.countyName}
              handleBlur={handleInputChange}
              handleChange={handleInputChange}
            />
          </Form.Group>
        </Form>
      </React.Fragment>
    );
  };

  selectAllCommunities = (event) => {
    let {communities, allCommunitiesSelection, tempOptions} = this.state;
    //allCommunitiesSelection = [...communities];
    //allCommunitiesSelection.allSelected = communities.allSelected;
    //let newTempOptions = [...tempOptions];
    allCommunitiesSelection = JSON.parse(JSON.stringify(communities));
    allCommunitiesSelection.allSelected = communities.allSelected;
    let newTempOptions = [];

    if (
      allCommunitiesSelection.allSelected != undefined &&
      allCommunitiesSelection.allSelected === true
    ) {
      allCommunitiesSelection.allSelected = !allCommunitiesSelection.allSelected;
    } else {
      allCommunitiesSelection.allSelected = true;
    }
    allCommunitiesSelection.forEach((community) => {
      community.selected = allCommunitiesSelection.allSelected;
      if (allCommunitiesSelection.allSelected) newTempOptions.push(community);
      else newTempOptions.splice(community);
    });

    this.setState({
      communities: allCommunitiesSelection,
      allCommunitiesSelection,
      tempOptions: newTempOptions,
    });
  };

  handleSelectCommunity = (event) => {
    let {communities, tempOptions} = this.state;
    let index;
    let communitySelectionCommunities = JSON.parse(JSON.stringify(communities));
    let newTempOptions = JSON.parse(JSON.stringify(tempOptions));
    if (event.target.checked) {
      newTempOptions.push(communitySelectionCommunities[event.target.value]);
      if (communitySelectionCommunities[event.target.value] !== undefined) {
        communitySelectionCommunities[event.target.value].selected = true;
      }
    } else {
      index = newTempOptions.indexOf(event.target.value);
      if (communitySelectionCommunities[event.target.value] !== undefined) {
        communitySelectionCommunities[event.target.value].selected = false;
      }
      var selectedIndex = newTempOptions.findIndex(
        (item) =>
          item.cidNumber == communitySelectionCommunities[event.target.value].cidNumber
      );
      newTempOptions.splice(selectedIndex, 1);
    }

    this.setState({
      tempOptions: newTempOptions,
      communities: communitySelectionCommunities,
    });
  };

  selectCommunityRecord = () => {
    let {communities, tempOptions} = this.state;
    let plan = this.getCommunity();
    const onChange = this.handleSelectCommunity;
    return (
      <React.Fragment>
        {communities.length > 0 ? (
          <div>
            <Divider />
            <React.Fragment>
              <div class="container_femagotable">
                <div class="sidescroll">
                  <FemaGoTable scrollable={10}>
                    <FemaGoTable.Header>
                      <FemaGoTable.Row>
                        <FemaGoTable.HeaderCell>
                          <input
                            id="selectAll"
                            name="selectAll"
                            title="select/deselect all"
                            type="checkbox"
                            onClick={this.selectAllCommunities}
                            checked={
                              communities != undefined ? communities.allSelected : false
                            }
                          />
                          &nbsp;
                          <label htmlFor="selectAll">Select all</label>
                        </FemaGoTable.HeaderCell>
                        <FemaGoTable.HeaderCell width={'three'}>
                          Community name
                        </FemaGoTable.HeaderCell>
                        <FemaGoTable.HeaderCell>County code</FemaGoTable.HeaderCell>
                        <FemaGoTable.HeaderCell>CID number</FemaGoTable.HeaderCell>
                        <FemaGoTable.HeaderCell>CRS community</FemaGoTable.HeaderCell>
                        <FemaGoTable.HeaderCell>CRS rating</FemaGoTable.HeaderCell>
                        <FemaGoTable.HeaderCell>
                          U.S. Congressional District
                        </FemaGoTable.HeaderCell>
                        <FemaGoTable.HeaderCell textAlign="center">
                          State
                        </FemaGoTable.HeaderCell>
                      </FemaGoTable.Row>
                    </FemaGoTable.Header>
                    <FemaGoTable.Body>
                      {communities &&
                        _.map(communities, (community, index) => {
                          return (
                            <FemaGoTable.Row key={index}>
                              <FemaGoTable.TextCell textAlign="center">
                                <input
                                  type="checkbox"
                                  name={'community_' + index}
                                  id={'community_' + index}
                                  value={index}
                                  checked={community.selected}
                                  onChange={onChange}
                                />
                              </FemaGoTable.TextCell>
                              <FemaGoTable.TextCell width={'three'}>
                                {community.communityName}
                              </FemaGoTable.TextCell>
                              <FemaGoTable.TextCell>
                                {community.countyCode}
                              </FemaGoTable.TextCell>
                              <FemaGoTable.TextCell>
                                {community.cidNumber}
                              </FemaGoTable.TextCell>
                              <FemaGoTable.TextCell>
                                {community.crsCommunity}
                              </FemaGoTable.TextCell>
                              <FemaGoTable.TextCell>
                                {community.crsRating}
                              </FemaGoTable.TextCell>
                              <FemaGoTable.TextCell>
                                {community.usCongressionalDistrict}
                              </FemaGoTable.TextCell>
                              <FemaGoTable.TextCell textAlign="center">
                                {community.state}
                              </FemaGoTable.TextCell>
                            </FemaGoTable.Row>
                          );
                        })}
                    </FemaGoTable.Body>
                  </FemaGoTable>
                </div>
              </div>
            </React.Fragment>
            <Divider />
            <Divider />
            <Divider />
            <br />
            <br />
            <Button
              primary
              disabled={tempOptions.length > 0 ? false : true}
              id="addCommunities"
              onClick={(e) => {
                plan.push(tempOptions);
                this.updateCommunity(tempOptions); // avoid add empty
              }}
              type="button"
            >
              Add communities
            </Button>
          </div>
        ) : null}
      </React.Fragment>
    );
  };

  handleRemoveCommunity = (index) => {
    let community = this.getCommunity();
    community.splice(index, 1);
    this.updateCommunity(community);
  };

  //delete Modal methods below
  renderDeleteModal = () => {
    return (
      <DeleteModal
        displayTitle={'Remove Community item'}
        open={this.state.deleteItemModalOpen}
        cancelAction={this.resetDeleteItem}
        deleteAction={this.confirmDeleteItem}
        displayText={
          'Are you sure you want to remove ' + this.state.deleteCommunityName + '?'
        }
      />
    );
  };

  openDeleteModal = () => this.setState({deleteItemModalOpen: true});
  closeDeleteModal = () => this.setState({deleteItemModalOpen: false});
  setDeleteItem = (id, communityName) => {
    this.setState(
      {deleteItemId: id, deleteCommunityName: communityName},
      this.openDeleteModal
    );
  };
  resetDeleteItem = () => {
    this.setState({deleteItemId: null}, this.closeDeleteModal);
  };

  confirmDeleteItem = () => {
    this.handleRemoveCommunity(this.state.deleteItemId);
    this.resetDeleteItem();
  };
  //End of Delete modal methods

  handleInputValueChange = (e) => {
    const {entityDataPath, entityType, data} = this.props;
    const {name, id, value} = e.target;
    const {communities} = this.state;

    const newOptions = produce(communities, (draftOptions) => {
      _.set(draftOptions, [id, 'usCongressionalDistrict'], value);
    });
    this.setState({
      communities: newOptions,
      options: newOptions,
    });
    this.props.saveEntityData(entityDataPath, entityType, newOptions);
  };

  componentDidMount() {
    let communities = this.getCommunity();
    this.setState({
      options: communities,
      communities: communities,
    });
  }

  render() {
    const {validationErrors, validationDirtyMap} = this.props;
    const validationErrorsArray =
      _.isEmpty(validationErrors) || _.isArray(validationErrors)
        ? validationErrors
        : [validationErrors];
    const firstError = _.find(validationErrorsArray, (err) => !err.isValid) || false;
    const errorMessage = firstError ? firstError.message : false;
    const displayError = firstError && _.get(validationDirtyMap, 'dirty');

    const options = _.cloneDeep(
      _.sortBy(_.uniqBy(this.state.options, 'cidNumber'), ['communityName'])
    );
    return (
      <React.Fragment>
        {this.renderDeleteModal()}
        <Grid.Column className="margin-top--standard">
          {!this.props.readOnly ? (
            <>
              <Button
                basic
                primary
                href="#"
                id="findCommunities"
                title="Find communities"
                onClick={() => this.handleFindCommunityButton(options)}
              >
                <Icon name="search" fitted />
                &nbsp;&nbsp;Find communities
              </Button>
              {displayError && <div className={'errorMessages'}>{errorMessage}</div>}
            </>
          ) : null}
        </Grid.Column>
        <br />
        <div>
          {options.length > 0 && (
            <FemaGoTable type="dynamic" scrollable={120} summary="Community details">
              <FemaGoTable.Header>
                <FemaGoTable.Row>
                  <FemaGoTable.HeaderCell>Community name</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>County code</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>CID number</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>CRS community</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>CRS rating</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>
                    U.S.
                    <br /> Congressional
                    <br /> District
                  </FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>&nbsp;</FemaGoTable.HeaderCell>
                </FemaGoTable.Row>
              </FemaGoTable.Header>
              <FemaGoTable.Body>
                {options &&
                  _.map(_.omitBy(options, _.isNil), (community, index) => (
                    <FemaGoTable.Row key={index}>
                      <FemaGoTable.TextCell>
                        {community.communityName}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>{community.countyCode}</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>{community.cidNumber}</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {community.crsCommunity}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>{community.crsRating}</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {!this.props.readOnly ? (
                          <InlineTextBoxField
                            id={index}
                            size="medium"
                            name="usCongressionalDistrict"
                            value={community.usCongressionalDistrict}
                            handleChange={this.handleInputValueChange}
                          />
                        ) : (
                          <div>{community.usCongressionalDistrict}</div>
                        )}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {!this.props.readOnly ? (
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.setDeleteItem(index, community.communityName);
                            }}
                          >
                            <Icon name="delete" />
                            Delete
                          </a>
                        ) : null}
                      </FemaGoTable.TextCell>
                    </FemaGoTable.Row>
                  ))}
              </FemaGoTable.Body>
            </FemaGoTable>
          )}
        </div>
        {this.renderFindCommunityModal()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    stateAddress:
      _.get(state, 'dynamicComponent.data.physicalAddress.state') ||
      _.get(
        state,
        'dynamicComponent.context.organization.physicalAddress.stateOrProvince'
      ),
    subApplicationType: _.get(
      state.dynamicComponent.data,
      'payload.subapplicant.subapplicantType'
    ),
    validationErrors: _.get(state.dynamicComponent, 'validationErrors'),
    validationDirtyMap: _.get(state.dynamicComponent, 'validationDirtyMap'),
  };
};

export default connect(mapStateToProps, null)(connectDynamic(CommunityCard));
